import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WindowRefService<T extends HTMLElement | Window = Window & Record<string, any>> {
  // Return the global native browser window object
  get nativeWindow(): T {
    return window as any;
  }
}
